import { render, staticRenderFns } from "./campfinder-select-item.vue?vue&type=template&id=10b3a41c"
import script from "./campfinder-select-item.vue?vue&type=script&lang=js"
export * from "./campfinder-select-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports